import {action, makeObservable, observable, runInAction} from 'mobx';
import {api} from '../../ApiFacade';
import {confirmAction, saveSuccess, showCommunicationError, showError, showWarning} from '../../helpers/alerts';
import {showLoaderAsync} from '../../helpers/loaders';


export class UserSettingsViewState {
    @observable
    newpassword?: string;
    @observable
    confirmnewpassword?: string;

    constructor() {
        makeObservable(this);
    }

    @action
    setNewPassword(v: string) {
        this.newpassword = v;
    }

    @action
    setConfirmNewPassword(v: string) {
        this.confirmnewpassword = v;
    }

    @action
    changePassword() {
        if (!this.newpassword || !this.confirmnewpassword) {
            showWarning('Invalid data', 'Please enter password and confirm it');
            return;
        }

        if (this.newpassword !== this.confirmnewpassword) {
            showWarning('Invalid data', 'Passwords doesn\'t match');
            return;
        }

        if (this.newpassword.length < 12) {
            showWarning('Invalid data', 'Password length must be greater than 12');
            return;
        }

        showLoaderAsync(api().userAuth.userAuthChangepasswordPost({
            body: this.newpassword
        }).then(() => {
            runInAction(() => {
                this.newpassword = '';
                this.confirmnewpassword = '';
            });

            saveSuccess(() => {
            });
        }).catch(err => {
            showError('Error when changing password', 'Please try again later', err);
        }));
    }

    deleteAccount() {
        confirmAction('It will delete all your projects and logs', () => {
            confirmAction('It will delete all your projects and logs. You need to cancel your subscription first', () => {
                api().userAuth.userAuthDelete().then(() => {
                    saveSuccess(() => {
                        document.location.href = 'https://www.muscula.com';
                    });
                }).catch((err: Error) => showCommunicationError(err));
            });
        });
    }
}
